import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLocale } from '../contexts/LocaleContext';
import { trackEvent, Events } from '../utils/webviewBridge';
import './ContentLock.css';

/** Full-page lock when onboarding is done but membership is inactive. */
const ContentLock = () => {
  const navigate = useNavigate();
  const { t } = useLocale();
  const copy = t.lock || {};

  useEffect(() => {
    trackEvent(Events.CONTENT_LOCK_VIEWED);
  }, []);

  return (
    <div className="clock">
      <div className="clock__panel">
        <p className="clock__brand">livefootball.space</p>
        <h1 className="clock__title">
          {copy.renewTitle || copy.guestTitle || 'Unlock to watch'}
        </h1>
        <p className="clock__text">
          {copy.renewText ||
            copy.guestText ||
            'Choose a plan to unlock live streams and scores.'}
        </p>

        <div className="clock__actions">
          <button
            type="button"
            className="clock__btn clock__btn--primary"
            onClick={() => navigate('/paywall')}
          >
            {copy.choosePlan || 'Choose a plan'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ContentLock;
